import { IColumns } from '../../../../../components/Dashboard/Table'
import { formatCryptoCurrency } from '../../../../../utils/formatCurrency'

export interface IData {
  columns: IColumns[]
}

export const data: IData = {
  columns: [
    {
      id: 'pair',
      label: 'ASSET',
    },
    {
      id: 'type',
      label: 'SIDE',
    },
    {
      id: 'quantity',
      label: 'QTY',
      format: (...args: Parameters<NonNullable<IColumns['format']>>): string => {
        const row = args[4]
        if (row?.quantity && row?.pair) {
          const [baseCurrency] = row.pair?.split('/')
          return formatCryptoCurrency(row?.quantity, baseCurrency)
        }

        return '-'
      },
    },
    {
      id: 'price',
      label: 'PRICE',
      format: (...args: Parameters<NonNullable<IColumns['format']>>): string => {
        const row = args[4]
        if (row?.price && row?.pair) {
          const [, quoteCurrency] = row.pair?.split('/')
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: quoteCurrency }).format(row.price)
        }

        return '-'
      },
    },
    {
      id: 'amount',
      label: 'AMOUNT',
      format: (...args: Parameters<NonNullable<IColumns['format']>>): string => {
        const row = args[4]
        if (row?.amount && row?.pair) {
          const [, quoteCurrency] = row.pair?.split('/')
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: quoteCurrency }).format(row.amount)
        }

        return '-'
      },
    },
    {
      id: 'fee',
      label: 'FEE',
      format: (...args: Parameters<NonNullable<IColumns['format']>>): string => {
        const row = args[4]
        if (row?.amount && row?.fee && row?.feeCurrency) {
          return new Intl.NumberFormat('en-US', { style: 'currency', currency: row.feeCurrency }).format(row.fee)
        }

        return '-'
      },
    },
    {
      id: 'status',
      label: 'STATUS',
    },
    {
      id: 'id',
      label: 'ORDER ID',
    },
    {
      id: 'timestamp',
      label: 'DATE',
      // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
      format: (value: string) => {
        const newDate = new Date(value)
        return newDate.toLocaleString()
      },
    },
  ],
}
